import { SearchService } from './search.service';

export const SERVICES = [
  SearchService
];
